<template>
  <div :class="{'NIGHT': isDark}" v-loading="loading" :style="{height: loading ? '100vh' : 'auto'}">
    <Nav :isDark="this.isDark"></Nav>
    <el-button class="to-bottom" circle icon="el-icon-caret-bottom" @click="scrollToBottom"></el-button>
    <el-backtop></el-backtop>
    <div class="container-fluid px-0" style="" v-if="!loading">
      <div :class="!isphone ? 'border-start border-end' : ''" :style="!isphone ? 'width:680px; margin: 0 auto;' : ''">
      <div class="d-flex justify-content-between align-items-center border-bottom  border-top py-1 px-2 bg-light sticky-header">
        <div>
          <el-button class="fs-14 py-0 text-primary" type="text" @click="centerDialogVisible = true">联赛选择</el-button>
          <el-button v-if="this.type === '足球'" class="fs-14 py-0 text-primary" type="text" @click="toggleHFA">{{ isHFA ? '主场优势' : '中立' }}</el-button>
        </div>
        <div>
          <el-date-picker v-model="dateVal" type="date" placeholder="选择日期" format="MM-dd" value-format="yyyy-MM-dd" size="mini" :editable="false" @change="changeDate"></el-date-picker>
          <!-- <router-link :to="'/qsda-tomorrow-m'" class="text-primary fs-12" style="cursor: pointer;">查看明日比赛>></router-link>
          <el-button class="fs-12 py-0 text-primary ms-2" type="text" @click="dataSwitch">窄实>></el-button> -->
        </div>
        <!-- <a class="text-primary fs-12" v-if="isTomorrow" @click="switeToTodayData" style="cursor: pointer;">返回今日比赛>></a> -->
      </div>
      <el-dialog title="联赛选择" :visible.sync="centerDialogVisible" width="90%" center>
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        <el-checkbox v-if="this.type === '足球'" v-model="checkMyLeague1" @change="handleCheckJingZu">竞足</el-checkbox>
        <el-checkbox v-if="this.type === '足球'" v-model="checkMyLeague2" @change="handleCheckBeiDan">北单</el-checkbox>
        <el-checkbox v-if="this.type === '足球'" v-model="checkMyLeague3" @change="handleCheckOthers">其他</el-checkbox>
        <div style="max-height: 50vh; overflow-y: scroll;">
          <el-checkbox-group v-model="checkedLeague" @change="handleCheckedLeagueChange">
            <el-checkbox v-for="(item,index) in league" :label="item" :key="index" :checked="isHide[index]" @change="change(isHide[index],item)">{{item}}</el-checkbox>
          </el-checkbox-group>
        </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
          </span>
      </el-dialog>
      <div class="text-center py-2 border-bottom">
        <el-radio-group v-model="type" size="small" @input="changeType">
          <el-radio-button label="足球"></el-radio-button>
          <el-radio-button label="篮球"></el-radio-button>
        </el-radio-group>
      </div>
      <div v-if="this.matchdata.length === 0 && !loading" :style="{height: this.matchdata.length === 0 ? 'calc(100vh - 156px)' : 'auto'}">
        <div class="nodata d-flex flex-column justify-content-center align-items-center" :class="{'h-100':this.matchdata.length === 0}">
          <span class="nodata">暂无比赛数据</span>
        </div>
      </div>
      <div v-if="this.matchdata.length > 0">
        <div v-for="(item,index) in matchdata" :key="index">
          <div :class="{'d-none': isHide[index]}">
            <div class="d-flex justify-content-between align-items-center py-2 border-bottom px-2">
              <div class="d-flex flex-column">
                <div>
                  <span class="fs-10 me-3" :style="{ color: item.color }">{{ item.league }}</span>
                  <span class="fs-10 time me-2">{{ type === '篮球' ? '' : formattedDateToMMDD(item.date,item.time) }}</span>
                  <span class="fs-10 time">{{ item.time }}</span>
                </div>
                <div class="d-flex">
                  <button class="btn ps-0" @click="addOrDelFav(index,item)">
                  <!-- <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" v-show="!isFav[index].selected" fill="#eee" class="bi bi-star-fill" :class="{'NIGHT': isDark}" viewBox="0 0 16 16">
                    <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                  </svg> -->
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#eee" class="bi bi-star-fill" :class="{'favSelected': isFav[index].selected}" viewBox="0 0 16 16">
                    <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                  </svg>
                </button>
                  <div class="d-flex flex-column">
                    <span>
                        <b class="fs-14">{{ item.home }}</b>
                        <font class="fs-12 ms-1">{{ filteredNum(item.home_rank) }}</font>
                    </span>
                    <span>
                        <b class="fs-14">{{ item.away }}</b>
                        <font class="fs-12 ms-1">{{ filteredNum(item.away_rank) }}</font>
                    </span>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-column pe-1">
                <span class="fs-10 d-flex justify-content-end align-items-center" style="height: 24px;">
                  <!-- <el-button type="text" class="p-0" @click="getHistory(item.qsda,item.handicap,item.bigsmall)">
                    <i class="el-icon-document fs-12" style="color: #ccc;"></i>
                  </el-button> -->
                  <router-link :to="{ path: '/charts/' + item.m_id, query: { teams: item.home+' VS '+item.away, hxg:item.hxg, axg:item.axg,hfa: item.hfa } }" class="text-decoration-none ms-2" tag="a" target="_blank">
                    <i class="el-icon-s-data fs-12" style="color: #ccc;"></i>
                </router-link>
                </span>
                <div class="d-flex" style="height: 48px;">
                  <div class="d-flex flex-column align-items-end justify-content-center">
                    <span class="fs-12 text-primary">{{ null == item.handicap || undefined == item.handicap ? '' : item.handicap }}</span>
                    <span class="fs-12 mt-1 text-primary">{{ null == item.bigsmall || undefined == item.bigsmall ? '' : item.bigsmall }}</span>
                  </div>
                  <a class="text-decoration-none d-flex flex-column justify-content-center align-items-end" :href="'https://m.titan007.com/analy/Analysis/'+item.id+'.htm'" target="_blank" style="width: 55px;">
                    <b class="fs-14 ps-3 qsdaColor" :style="{color: qsdaColorSet(item.handicap,qsdaVal(item.qsda,item.hxg,item.hfa,item.axg))}">{{ item.hxg === 0 && item.axg === 0 ? '' : qsdaVal(item.qsda,item.hxg,item.hfa,item.axg) }}</b>
                    <b class="fs-14 ps-3" :style="{color: bsColorSet(item.bigsmall,bsVal(item.hxg,item.hfa,item.axg))}">{{ item.hxg === 0 && item.axg === 0 ? '' : bsVal(item.hxg,item.hfa,item.axg) }}</b>
                  </a>
                </div>
              </div>
              <!-- <div class="team d-flex align-items-center"> -->
                <!-- <button class="btn" @click="addOrDelFav(index,item)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" v-show="!isFav[index]" fill="#eee" class="bi bi-star-fill" viewBox="0 0 16 16">
                    <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" v-show="isFav[index]" fill="#ffc107" class="bi bi-star-fill" viewBox="0 0 16 16">
                    <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                  </svg>
                </button> -->
                <!-- <div class="flex-fill text-end d-flex flex-column">
                  <span class="fs-10" :style="{ color: callSetColor(item.color,item.name) }">{{ item.name }}</span>
                  <span>
                    <font class="fs-12 me-1">{{ filteredNum(item.homerank) }}</font>
                    <b class="fs-14">{{ item.home }}</b>
                  </span>
                    <span class="fs-10" style="color:#e6b272;">{{ item.handicap }}</span>
                </div>
              </div> -->
              <!-- <div class=" d-flex flex-column">
                <span> </span>
                <a class="text-decoration-none" :href="'https://m.nowscore.com/Analy/ShiJian/'+item.id+'.htm'" target="_blank"><b class="fs-14 px-3 qsdaColor" :style="{color: qsdaColorSet(item.handicap,item.qsda)}">{{ item.qsda }}</b></a>
                <span> </span>
              </div> -->
              <!-- <div class="team d-flex align-items-center">
                <div class="flex-fill d-flex flex-column">
                  <span class="fs-10 time">{{ item.time }}</span>
                  <span>
                    <b class="fs-14">{{ item.away }}</b>
                    <font class="fs-12 ms-1">{{ filteredNum(item.awayrank) }}</font>
                  </span>
                  <span class="fs-10" style="color:#e6b272;">{{ item.bigsmall }}</span>
                </div>
                <div style="width: 26px;height: 26px;"></div>
                <router-link :to="{ path: '/charts/' + item.id, query: { teams: item.home+' VS '+item.away } }" class="text-decoration-none" tag="a" target="_blank">
                  <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="18px" viewBox="0 0 24 24" width="18px" fill="#0d6efd"><g><rect fill="none" height="18" width="18"/></g><g><g><path d="M21,8c-1.45,0-2.26,1.44-1.93,2.51l-3.55,3.56c-0.3-0.09-0.74-0.09-1.04,0l-2.55-2.55C12.27,10.45,11.46,9,10,9 c-1.45,0-2.27,1.44-1.93,2.52l-4.56,4.55C2.44,15.74,1,16.55,1,18c0,1.1,0.9,2,2,2c1.45,0,2.26-1.44,1.93-2.51l4.55-4.56 c0.3,0.09,0.74,0.09,1.04,0l2.55,2.55C12.73,16.55,13.54,18,15,18c1.45,0,2.27-1.44,1.93-2.52l3.56-3.55 C21.56,12.26,23,11.45,23,10C23,8.9,22.1,8,21,8z"/><polygon points="15,9 15.94,6.93 18,6 15.94,5.07 15,3 14.08,5.07 12,6 14.08,6.93"/><polygon points="3.5,11 4,9 6,8.5 4,8 3.5,6 3,8 1,8.5 3,9"/></g></g></svg>
                </router-link>
              </div> -->
            </div>
            <!-- <div class="history-list collapse border-bottom py-2" :id="'collapse' + index+1">
              <div v-for="(element,i) in historyList[index]" :key="i">
                <div v-if="this.historyList[index].length == 0" class="text-center">无回查数据</div>
                <div v-if="this.historyList[index].length !== 0">{{ element.name }}</div>
              </div>
            </div> -->
          </div>
        </div>
      </div></div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
// import jsonData from '@/data/tomorrow.json';
import Nav from './comment/nav.vue';
import Footer from './comment/footer.vue'
import {setcolor } from '@/utils/setcolor';
import { checkColor, handicapToNum, convertToReal, compare, dateFormatted,calculateScores,poissonDist,scrollToBottom, fbBsVal, footballBsColorSet, bbBsVal, basketballZsColorSet, basketballBsColorSet, basketballZsVal, isMobile } from '../utils/utils'
import { getGuoCaiLeague, getFbZsMatches, getBbZsMatches } from '../constants/http.config';
export default {
  components: { Nav,Footer },
  inject: ['reload'],
  data() {
    return {
      matchdata: [],
      historyList: [],
      isFav: [],
      favList: [],
      bbFavList: [],
      isHide: [],
      league: [],
      checkedLeague: [],
      idList: [],
      myLeague1: [],//竞足
      myLeague2: [],//北单
      myLeague3: [],//其他
      isDark: false,
      goalList: [0,1,2,3,4,5,6,7,8,9,10],
      allLg: [],
      checkedLeagueVal: [],
      isToday: true,
      isTomorrow: false,
      loading: true,
      dateStr: '',
      dateParams: '',
      dateVal:'',
      type: '足球',
      centerDialogVisible: false,
      isIndeterminate: false,
      checkAll: true,
      checkMyLeague1: false,
      checkMyLeague2: false,
      checkMyLeague3: false,
      isZs: true,
      isHFA: false,
      isphone: true,
    }
  },
  mounted() {
    if (this.isMobile() === 'mobile') {
      this.isphone = true;
    }else{
      this.isphone = false;
    }
    // 设置过期时间为每天的10:30
    // var now = new Date();
    // var millisTill10 = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 10, 30, 0, 0) - now;
    // if (millisTill10 < 0) {
    //     millisTill10 += 86400000; // 如果时间已经过了，那么设置的是明天的10:30
    //     localStorage.removeItem('favList');
    //     localStorage.removeItem('favState');
    // }
    const favExpStr = localStorage.getItem('favListExpirationDate')
    const favStExpStr = localStorage.getItem('favStateExpirationDate')
    const favExp = JSON.parse(favExpStr)
    const favStExp = JSON.parse(favStExpStr)
    // if (favExp) {
      
    // }
    this.dateParams = this.$route.params.date;
    let date = dateFormatted(new Date());
    this.dateVal = date;
    this.getData();
    // this.getCheckLeague()
  },
  methods: {
    scrollToBottom,
    dateFormatted,
    handicapToNum,
    checkColor,
    convertToReal,
    compare,
    poissonDist,
    calculateScores,
    footballBsColorSet,
    isMobile,
    callSetColor(color,league){
            return setcolor(color,league);
        },
    filteredNum(str){
      if (null == str || '' == str) {
        return '';
      }else{
        const rank = str.match(/\d+/) !==null ? '['+str.match(/\d+/)[0]+']' : '';
        return rank;
      }
    },
    getCheckLeague(){
      const url = getGuoCaiLeague;
      fetch(url)
      .then(response => response.json())
      .then(data => {
          // console.log('cccccckkk',this.myLeague1,this.myLeague2);
          this.myLeague1 = data.data[0].data;
          this.myLeague2 = data.data[1].data;
          this.myLeague3 = this.allLg.filter(item => !this.myLeague2.includes(item));
          const filterLg3 = [...new Set(this.myLeague3)];
          this.myLeague3 = filterLg3;
      }).catch(err=>{
          console.log('读取数据出错',err);
          this.loading = false;
      })
    },
    getData(){
      let date = dateFormatted(new Date());
      // 设置目标时间为 10:30 AM
      let targetTime = new Date();
      let currentTime = new Date();
      targetTime.setHours(10);
      targetTime.setMinutes(35);
      targetTime.setSeconds(0);
      if (this.dateParams !== undefined) {
        date = this.dateParams;
      }else{
        // 比较当前时间和目标时间
        if (currentTime > targetTime) {
            console.log("当前时间大于 10:35 AM，读取今日数据");
            date = this.dateFormatted(currentTime);
        } else {
            console.log("当前时间小于 10:35 AM，读取昨天数据");
            // 将日期减一天
            currentTime.setDate(currentTime.getDate() - 1)
            date = this.dateFormatted(currentTime);
            // console.log(dateParams);
        }
      }
      // const url = 'https://api.qsda.net/api/match/'+date;
      // const url = 'https://api.qsda.net/api/match/date/' + date;
      // const url = '/football/match/' + date;
      const url = getFbZsMatches + date;
      console.log(url);
      this.fetchZs(url)
      // fetch(url)
      // .then(response => response.json())
      // .then(data => {
      //   // this.dateStr = data.data[0].date;
        
      //   // 从 localStorage 中获取字favlist
      //   let favstr = localStorage.getItem('favList')
      //   if (favstr == '[]') {
      //     localStorage.removeItem('favList')
      //   }
      //   let favListStr = JSON.parse(localStorage.getItem('favList'));
      //   // 从 localStorage 中获取字favState
      //   let favStateStr = JSON.parse(localStorage.getItem('favState'));
      //   // let fav = []
      //   for (let index = 0; index < data.data.length; index++) {
      //     this.isFav.push({
      //       id: data.data[index].id,
      //       selected: false
      //     });
      //   }
      //   // console.log(data.data[0].date==favListStr[0].date);
        
      //   //如果收藏列表没数据,读取localStorage的
      //     if (this.favList.length == 0) {
      //       //没有收藏，添加
      //       if (null == favListStr) {
      //         console.log('favListStr收藏空,添加');
      //         // localStorage.setItem('favList', '[]');
      //       }else{
      //         //如果已经有收藏列表，读取localStorage的收藏列表
      //         if (favListStr.length !== 0 || favListStr !== '[]') {
      //         console.log('favListStr不空,读取值');
      //           //判断日期是否相同
      //           if (favListStr[0].date !== data.data[0].date) {
      //             this.favList = []
      //           }else{
      //             this.favList = favListStr;
      //           }
      //         }
      //       }
            
      //     }
      //     //如果收藏状态为空，添加初始状态
      //     if(null == favStateStr){
      //       console.log('favStateStr收藏状态空');
      //       // localStorage.setItem('favState', '[]');
      //       // for (let index = 0; index < data.data.length; index++) {
      //       //   this.isFav = fav;
      //       // }
      //     }else{
      //       //如果收藏状态列表不为空，读取localStorage的收藏状态
      //       if (favStateStr.length !== 0 && null !== favListStr){
      //       //判断日期是否相同,相同读取状态，不同设为初始
      //       if (favListStr[0].date !== data.data[0].date) {
      //           // this.isFav = fav;
      //         }else{
      //           this.isFav = favStateStr;
      //         }
      //       }
      //     }
          
        
      //           // const today = new Date();
      //           // const tomorrow = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
      //           // const currentHours = today.getHours()
      //           // const currentMin = today.getMinutes();
      //           // if (currentHours < 10 || currentHours == 10 && currentMin < 30) {
      //           //     console.log('现在时间小于10:30');
      //               // 读取今日赛程
      //               this.loading = false;
      //               this.matchdata = data.data;
      //               const leagueSet = new Set(this.matchdata.map((item) => item.name));
      //               const leagueArray = Array.from(leagueSet);
      //               this.league = leagueArray.map((item) => (item));
      //               this.checkedLeague = this.league;
      //               //联赛显示隐藏状态赋值
      //               for (let index = 0; index < this.matchdata.length; index++) {
      //                 this.isHide.push(false);
      //               }
                    
      //               // for (let index = 0; index < this.league.length; index++) {
      //               //   this.checkedLeague.push(true);
      //               // }
      //               // console.log(this.checkedLeague);
                    
      //               // this.dataStr = this.data[0].date;
      //       //     }
      //       //     else if (data.data[0].date == this.dateFormatted(tomorrow)) {
      //       //         console.log('日期是今日');
      //       //         this.loading = false;
      //       //         this.matchdata = data.data;
      //       //         this.dataStr = data.data[0].date
      //       //     }else{
      //       //       console.log('没有数据');
      //       //       this.matchdata = [];
      //       //       this.loading = false;
      //       //       this.dataStr == ''
      //       //     }
      //       })
      //       .catch(error => console.error('Error:', error));
    },
    async getHistory(qsda,init,bsInit){
      let res = []
      const url = 'https://api.qsda.net/api/match/history?';
      // const url = 'localhost:8888/api/match/history?';
      await fetch(url + 'qsda=' + qsda + '&init=' + init + '&bsInit=' + bsInit + '&pageNum=1&pageSize=20', {
          method: 'get',
          headers: {
              'Content-Type': 'application/json',
          },
      })
      .then(response => response.json())
      .then(data => {
              res = data.data.list;
              this.historyList.push(res);
              console.log(res);
      });
      // console.log(res);
    },
    addOrDelFav(index,item){
        this.$set(this.isFav[index], 'selected', !this.isFav[index].selected);
        console.log('favbtn',this.isFav[index]);
        // if (this.idList.length === 0) {
        //   this.idList.push({
        //     id: item.id,
        //     isFav: true
        //   })
        // }else{
        //   for (let index = 0; index < this.idList.length; index++) {
        //     if (this.idList.indexOf(item.id) == -1) {
        //       this.idList.push({
        //         id: item.id,
        //         isFav: true
        //       })
        //     }
        //   }
        // }
        // console.log(this.idList);
        
        // 设置过期时间为1天后
        // var expiration = new Date().getTime() + (24 * 60 * 60 * 1000);
        // 设置过期时间为每天的10:30
        var now = new Date();
        var millisTill10 = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 10, 30, 0, 0) - now;
        if (millisTill10 < 0) {
            millisTill10 += 86400000; // 如果时间已经过了，那么设置的是明天的10:30
        }
        if (this.isFav[index].selected) {
          this.favList.push(item);
          //保存到 localStorage
          let favListStr = JSON.stringify(this.favList);
          let favStateStr = JSON.stringify(this.isFav);
          if (this.type === '足球') {
            localStorage.setItem('favList', favListStr);
            localStorage.setItem('favListExpirationDate', JSON.stringify({
              value: 'favListStr',
              expiration: now.getTime() + millisTill10
            }));
            localStorage.setItem('favState', favStateStr);
            localStorage.setItem('favStateExpirationDate', JSON.stringify({
              value: 'favStateStr',
              expiration: now.getTime() + millisTill10
            }));
          }
          if (this.type === '篮球') {
            localStorage.setItem('bbFavList', favListStr);
            localStorage.setItem('bbFavListExpirationDate', JSON.stringify({
              value: 'bbFavListStr',
              expiration: now.getTime() + millisTill10
            }));
            localStorage.setItem('bbFavState', favStateStr);
            localStorage.setItem('bbFavStateExpirationDate', JSON.stringify({
              value: 'bbFavStateStr',
              expiration: now.getTime() + millisTill10
            }));
          }
        }else{
          if (this.type === '足球') {
            this.favList.splice(this.favList.indexOf(item),1);
            //保存到 localStorage
            let favListStr = JSON.stringify(this.favList);
            let favStateStr = JSON.stringify(this.isFav);
            localStorage.setItem('favList', favListStr);
            localStorage.setItem('favState', favStateStr);
          }
          if (this.type === '篮球') {
            this.favList.splice(this.bbFavList.indexOf(item),1);
            let favListStr = JSON.stringify(this.bbFavList);
            let favStateStr = JSON.stringify(this.isFav);
            localStorage.setItem('bbFavList', favListStr);
            localStorage.setItem('bbFavState', favStateStr);
          }
        }
        // console.log(this.favList);
    },
    qsdaColorSet(handicap,qsda){
      let qsdaColor = 'rgb(128,0,255)';
      if (this.type === '足球') {
        let lowOrHight = 2;
        if (handicap!=='' || null !== handicap || undefined !== handicap) {
            const handicapNum = handicapToNum(handicap);
            const realHandicapNum = convertToReal(qsda);
            // console.log(handicapNum, realHandicapNum);
            if (handicapNum === 0) {
                qsdaColor = 'rgb(128,0,255)';
            }else{
                if (typeof handicapNum !== 'undefined' && typeof realHandicapNum !== 'undefined') {
                        lowOrHight = compare(handicapNum, realHandicapNum);
                    if(lowOrHight === 0){
                        qsdaColor = '#666';
                    }
                    if (lowOrHight === 1) {
                        qsdaColor = 'red';
                    }
                    if (lowOrHight === -1) {
                        qsdaColor = 'green';
                    }
                }
            }
        }
        return qsdaColor
      }
      if (this.type === '篮球') {
        if(null == handicap || undefined == handicap){
          return qsdaColor
        }else{
          return basketballZsColorSet(handicap,qsda);
        }
        
      }
    },
    bsColorSet(bigsmall,bs){
      if (null !== bigsmall || undefined !== bigsmall) {
        if (this.type === '足球') {
          return footballBsColorSet(bigsmall,bs)
        }
        if (this.type === '篮球') {
          return basketballBsColorSet(bigsmall,bs)
        }
      }else{
        return 'rgb(128,0,255)';
      }
    },
    istoday(){
        const today = new Date();
        if (this.dateStr == this.dateFormatted(today)) {
        console.log('istoday true');
            return true
        }else{
            console.log('istoday false');
            return false
        }
    },
    istomorrow(){
      console.log(this.dateStr);
        const today = new Date();
        const tomorrow = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        if (this.dateStr == this.dateFormatted(tomorrow)) {
        console.log('istomorrow true');
            return true
        }else{
            console.log('istomorrow false');
            return false
        }
    },
    handleCheckedLeagueChange(value) {
      // console.log(value,'lllll');
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.league.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.league.length;
      
        //   for (let index = 0; index < this.matchdata.length; index++) {
        //     const leagueName = this.matchdata[index].league;
        //     // console.log(leagueName.includes(checkElm),checkElm,leagueName);
        //     for (let i = 0; i < value.length; i++) {
        //       const checkElm = value[i];
        //       if (leagueName.includes(checkElm)) {
        //         this.isHide[index] = true;
        //         console.log('yyy',checkElm,leagueName,this.isHide[index]);
        //       }
        //   }
        // }
    },
    //全选联赛
    handleCheckAllChange(val) {
      // console.log('0000');
      this.checkedLeague = val ? this.league : [];
      this.checkMyLeague1 = false;
      this.checkMyLeague2 = false;
      this.checkMyLeague3 = false;
      this.isIndeterminate = false;
      //设置全选或全不选      
      for (let index = 0; index < this.isHide.length; index++) {
        if (val) {
          this.isHide[index] = false;
        }else{
          this.isHide[index] = true;
        }
      }
    },
    //竞足
    handleCheckJingZu(val) {
      // console.log('jz',val,);
      this.checkedLeague = val ? this.myLeague1 : [];
      if (!val) {
        this.checkAll = true;
        this.checkedLeague = this.league;
        for (let index = 0; index < this.isHide.length; index++) {
          if (!val) {
            this.isHide[index] = false;
            // console.log(this.isHide[index]);
            
          }else{
            this.isHide[index] = true;
            // console.log(this.isHide[index]);
          }
        }
      }else{
        this.checkAll = false;
        this.checkMyLeague2 = false;
        for (let index = 0; index < this.matchdata.length; index++) {
          const all = this.matchdata[index].league;
          // console.log('all',all);
          let isMatchFound = false;
          for (let i = 0; i < this.myLeague1.length; i++) {
            const check = this.myLeague1[i];
            // console.log('check',check);
            if (check === all) {
              // console.log('check === all',all,check);
              isMatchFound = true;
              // break; // 找到匹配就可以跳出循环
            }
          }
          this.isHide[index] = !isMatchFound; // 如果找到匹配值，则 isHide 为 false；否则为 true
          // console.log(this.isHide[index],index,'8888');
          
        }
      }
    },
    //北单
    handleCheckBeiDan(val) {
      this.checkedLeague = val ? this.myLeague2 : [];
      if (!val) {
        this.checkAll = true;
        this.checkedLeague = this.league;
        for (let index = 0; index < this.isHide.length; index++) {
          if (!val) {
            this.isHide[index] = false;
          }else{
            this.isHide[index] = true;
          }
        }
      }else{
        this.checkAll = false;
        this.checkMyLeague1 = false;
        for (let index = 0; index < this.matchdata.length; index++) {
          const all = this.matchdata[index].league;
          let isMatchFound = false;
          for (let i = 0; i < this.myLeague2.length; i++) {
            const check = this.myLeague2[i];
            if (check === all) {
              isMatchFound = true;
              break; // 找到匹配就可以跳出循环
            }
          }
          this.isHide[index] = !isMatchFound; // 如果找到匹配值，则 isHide 为 false；否则为 true
        }
      }
    },
    //其他
    handleCheckOthers(val) {
        this.filterData = [];
        this.checkedLeague = val ? this.myLeague3 : [];
        // console.log('5556666',this.myLeague3);
        this.isSel = true;
        if (!val) {
            this.checkAll = true;
            this.checkedLeague = this.league;
            this.filterData = this.matches;
        }else{
            this.checkAll = false;
            this.checkMyLeague1 = false;
            this.checkMyLeague2 = false;
            let cout = 0;
            for (let index = 0; index < this.matchdata.length; index++) {
                // const elm = this.matches[index];
                const all = this.matchdata[index].league;
                let isMatchFound = false;
                for (let i = 0; i < this.myLeague3.length; i++) {
                    const check = this.myLeague3[i];
                    if (check === all) {
                        // console.log('ffff',check,all);
                        cout ++;
                        // this.filterData.push(elm);
                        isMatchFound = true;
                        break; // 找到匹配就可以跳出循环
                    }
                }
              this.isHide[index] = !isMatchFound; // 如果找到匹配值，则 isHide 为 false；否则为 true
            }
            // console.log('33388888',cout,this.checkedLeagueVal,this.checkedLeague);
        }
    },
    change(val,name){
      console.log(val,name,this.matchdata.length,this.isHide.length);
      // this.isHide[index] = !this.isHide[index];
      for (let index = 0; index < this.matchdata.length; index++) {
        const elm = this.matchdata[index].league;
        // console.log('000',elm,this.isHide[index]);
        if (name === elm) {
          this.isHide[index] = !this.isHide[index];
          // console.log(index+1,elm,this.isHide[index]);
        }
      }
    },
    formattedDateToMMDD(date,time){
      const formattedDate = date.slice(5);
      if (time < '12:00') {
        const [month, day] = formattedDate.split('-').map(Number);
        // 获取当前年份
        const currentYear = new Date().getFullYear();
        // 创建一个新的 Date 对象，年份可以随意设置
        const d = new Date(currentYear, month - 1, day);
        // 日期加1天
        d.setDate(d.getDate() + 1);
        // 格式化新的日期
        const newMonth = String(d.getMonth() + 1).padStart(2, '0');
        const newDay = String(d.getDate()).padStart(2, '0');
        const newDateStr = `${newMonth}-${newDay}`;
        return newDateStr;
      }else{
        return formattedDate;
      }
    },
    //读取窄实比赛
    fetchZs(url){
      fetch(url)
      .then(response => response.json())
      .then(data => {
          this.loading = false;
          this.matchdata = data.data;
          // console.log('tttt',data.data.length)
          this.getCheckLeague();
          this.dateStr = data.data.length > 0 ? data.data[0].date : ''
          // 从 localStorage 中获取字favlist
          let favstr = localStorage.getItem('favList')
          let favList = JSON.parse(localStorage.getItem('favList'));
          // 从 localStorage 中获取字favState
          let favState = JSON.parse(localStorage.getItem('favState'));
          console.log('favList',favList,'favState',favState, this.favList.length);
          //如果收藏列表为空，初始化收藏状态为false
          if (favstr == '[]') {
            localStorage.removeItem('favList');
            for (let index = 0; index < data.data.length; index++) {
              this.isFav.push({
                id: data.data[index].id,
                selected: false
              });
            }
          }
          let fav = []

          if (this.matchdata.length == 0) {
              this.emptyText = '暂无数据';
          }else{
            //如果收藏状态为空，添加初始状态
            if(null == favState){
              console.log('favStateStr收藏状态空');
              localStorage.setItem('favState', '[]');
              // for (let index = 0; index < data.data.length; index++) {
              //   this.isFav = fav;
              // }
            }else{
              //如果收藏状态列表不为空，读取localStorage的收藏状态
              if (favState.length !== 0 && null !== favList){
                //判断日期是否相同,相同读取状态，不同设为初始
                if (favList[0].date !== this.matchdata[0].date) {
                  // this.isFav = fav;
                }else{
                  this.isFav = favState;
                }
              }
            }
            // console.log('qazxsw',this.isFav);
            this.emptyText = '加载中...';
            const leagueSet = new Set(this.matchdata.map((item) => item.league));
            const leagueArray = Array.from(leagueSet);
            this.league = leagueArray.map((item) => (item));
            this.checkedLeague = this.league;
            for (let index = 0; index < this.matchdata.length; index++) {
              this.allLg.push(this.matchdata[index].league);
              this.isFav.push({
                id: data.data[index].id,
                selected: false
              });
            }
            //如果收藏列表没数据,读取localStorage的
            if (this.favList.length == 0) {
              //没有收藏，添加
              if (null == favList) {
                console.log('favListStr收藏空,添加');
                localStorage.setItem('favList', '[]');
              }else{
                console.log('favL',favList);
                //如果已经有收藏列表，读取localStorage的收藏列表
                if (favList.length !== 0) {
                  console.log('favListStr不空,读取值',favList);
                  //判断日期是否相同
                  if (favList[0].date !== data.data[0].date) {
                    this.favList = []
                  }else{
                    this.favList = favList;
                  }
                  console.log('this.favList === 0',this.favList);
                }
              }
            }
            for (let index = 0; index < this.checkedLeague.length; index++) {
                // const element = this.checkedLeague[index];
                this.checkedLeagueVal.push(true);
            }
            this.matchdata.forEach(item => {
                const homeXg = item.hxg;
                const awayXg = item.axg;
                // console.log(item.home,item.away,homeXg,awayXg,homeXg !== 0 && awayXg !== 0);
                
                let poissonList = []; // 在每次循环开始时重新初始化
                // if ( homeXg !== 0 && awayXg !== 0 ) {
                    for (let i = 0; i < this.goalList.length; i++) {
                        const elm = this.goalList[i];
                        const h = this.poissonDist(elm, homeXg, false);
                        const a = this.poissonDist(elm, awayXg, false);
                        const res = {
                            id: item.id, home: h, away: a
                        }
                        poissonList.push(res);
                    }
                    const res = this.calculateScores(poissonList);
                    item.poisson = res;
                    // console.log(item.poisson);
                // }
            })
            // console.log('1111',this.allLg.length);
          }
      }).catch(err=>{
          this.loading = false;
          console.log('读取数据出错',err);
      })
    },
    getBasketballData(url){
      fetch(url)
      .then(response => response.json())
      .then(data => {
        let favList = JSON.parse(localStorage.getItem('bbFavList'));
        // 从 localStorage 中获取字favState
        let favState = JSON.parse(localStorage.getItem('bbFavState'));
        console.log('bbFavList',favList,'bbFavState',favState);
        //如果收藏列表没数据,读取localStorage的
        // if (this.bbFavList.length == 0) {
        //   //没有收藏，添加
        //   if (null == favList) {
        //     console.log('bbFavListStr收藏空,添加');
        //     localStorage.setItem('bbFavList', '[]');
        //   }else{
        //     //如果已经有收藏列表，读取localStorage的收藏列表
        //     if (favList.length !== 0) {
        //       console.log('bbFavListStr不空,读取值',favList);
        //       //判断日期是否相同
        //       if (favList[0].date !== data.data[0].date) {
        //         this.favList = []
        //       }else{
        //         this.favList = favList;
        //       }
        //     }
        //   }
        // }
        //如果收藏状态为空，添加初始状态
        if(null == favState){
          console.log('bbFavStateStr收藏状态空');
          localStorage.setItem('bbFavState', '[]');
          // for (let index = 0; index < data.data.length; index++) {
          //   this.isFav = fav;
          // }
        }else{
          //如果收藏状态列表不为空，读取localStorage的收藏状态
          if (favState.length !== 0 && null !== favList){
          //判断日期是否相同,相同读取状态，不同设为初始
          if (favList[0].date !== data.data[0].date) {
              // this.isFav = fav;
            }else{
              this.isFav = favState;
            }
          }
        }

        this.matchdata = data.data;
        if (this.matchdata.league === 0) {
          this.loading = false;
          this.emptyText = '暂无数据';
        }else{
          this.emptyText = '加载中...';
          for (let index = 0; index < this.matchdata.length; index++) {
            // this.allLg.push(this.matchdata[index].league);
            this.isFav.push({
              id: data.data[index].id,
              selected: false
            });
          }
          let basketballFavList = JSON.parse(localStorage.getItem('bbFavList'));
          if (this.bbFavList.length == 0) {
            if (null == basketballFavList) {
              console.log('篮球收藏状态空');
              localStorage.setItem('bbFavList', '[]');
              // localStorage.setItem('bbFavState', '[]');
            }
          }
          console.log('篮球',data.data.length);
          // setTimeout(() => {
            this.loading = false;
          // }, 200);
          const leagueSet = new Set(this.matchdata.map((item) => item.league));
          const leagueArray = Array.from(leagueSet);
          this.league = leagueArray.map((item) => (item));
          this.checkedLeague = this.league;
        }
      }).catch(err=>{
          console.log('读取数据出错',err);
          this.loading = false;
      })
    },
    dataSwitch(){
      console.log('0000');
      this.matchdata = [];
      const date = this.dateVal;
      const url = '/football/match/' + date;
      this.fetchData(url)
    },
    changeDate(){
      const date = this.dateVal;
      this.matchdata = [];
      const url = getFbZsMatches + date;
      console.log(date,url);
      this.fetchZs(url);
    },
    qsdaVal(qsda,hxg,hfa,axg){
      // console.log('qsdaval...',hxg,hfa,axg);
      let val = null;
      if (qsda !== null) {
        val = qsda;
      }else{
        if (hxg ===null || axg === null || hxg === 0 || axg === 0) {
          val = '';
        }else{
          if (hfa !== null || hfa !== undefined || hfa !== 0) {
            if (this.type === '足球') {
              if (this.isHFA) {
                val = Math.round((hxg*(1+hfa)-axg*(1-hfa)) * 100)
              }
              val = Math.round((hxg - axg) * 100)
            } else {
              const qsda = Math.round((hxg-axg) * 100)/100
              val = basketballZsVal(qsda)
              // console.log('bbbbval...',res);
            }
          }else{
            val = Math.round((hxg-axg) * 100)
          }
        }
    }
    return val;
  },
    bsVal(hxg,hfa,axg){
      if (this.type === '足球') {
        return fbBsVal(hxg*(1+hfa)+axg*(1-hfa));
      }
      if (this.type === '篮球') {
        return bbBsVal(hxg+axg);
      }
    },
    changeType(){
      const date = new Date();
      let url = getFbZsMatches + this.dateVal;
      this.matchdata = [];
      this.isFav = [];
      this.loading = true;
      this.checkedLeague = []
      this.league = [];
      if (this.type === '足球') {
        // url = '/football/match/zs/' + this.dateVal;
        console.log('fb...',url,date);
        this.fetchZs(url)
      }
      if (this.type === '篮球') {
        url = getBbZsMatches + this.dateVal;
        console.log('bb...',url,date);
        this.getBasketballData(url)
      }
    },
    toggleHFA(){
      this.isHFA = !this.isHFA;
      console.log('主场优势',this.isHFA);
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/sass/global.scss';
.team { width: 45%;}
font,.time {color: rgb(136, 136, 136);}
.el-checkbox {min-width: 100px; padding: 3px 0; margin-right: 5px;}
::v-deep .el-dialog--center .el-dialog__body {padding: 0 25px 0;}
::v-deep .el-input__inner {height: 22px!important; line-height: 22px!important; border: none;}
::v-deep .el-input__icon { line-height: 22px!important;}
::v-deep .el-input--suffix .el-input__inner {padding-right: 0!important;}
::v-deep .el-date-editor.el-input, .el-date-editor.el-input__inner {width: 110px;}
.el-input--mini { font-size: 16px!important;}
::v-deep .el-input__inner {height: 28px !important;line-height: 28px !important;}
@media (max-width:1024px) {
  .el-checkbox {margin-right: 0;}
.sticky-header {
  position: sticky;
  top: 0;               /* 距离顶部 0px 时开始粘住（可改成 60px 等） */
  z-index: 1000;        /* 防止被其他元素覆盖 */
  background: #fff;     /* 通常需要背景色，避免透明 */
  /* 可选：加阴影或过渡 */
  // box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  // transition: all 0.3s;
}
}
@media (max-width:391px) {
  .el-checkbox {min-width: 90px!important;}
}
</style>
